export { default as RouteShape } from 'ha/types/apollo/ApolloRouteShape';

export interface HermesState {
  info?: HermesInfo;
  data?: {};
  error: boolean;
}

export interface HermesInfo {
  id: string;
  path: string;
  type: string;
  hasData: boolean;
  availableLanguages: string[];
  meta: {
    alternateHrefs: { [lang: string]: string };
    canonical: string;
  };
}

export interface HermesResponse {
  data: object;
  info: HermesInfo;
}

export type LinkData =
  | {
      rel: 'canonical';
      href: string;
    }
  | {
      rel: 'alternate';
      href: string;
      hrefLang: string;
    };
